import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import OperationsProjectService from '../../../../Services/OperationsProjectService';
import dateTimeHelper from '../../../../Helpers/datetimeHelper';
import ErrorMessage from '../../../ErrorMessage';

export default class ProjectSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    idFilter: null,
    onlyActive: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idFilter !== prevProps.idFilter) {
      this.populateListData();
    }
  }

  populateListData() {
    if (!this.props.idFilter) {
      this.setState({ selectValues: [] });
      return;
    }

    OperationsProjectService.GetProjectListByClientId(this.props.idFilter)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result
          .sort((a, b) => (a.cfDisplayName > b.cfDisplayName ? 1 : -1))
          .forEach((project, index) => {
            if (!this.props.onlyActive || this.isStartedProject(project)) {
              optValues.push({
                label: project.cfDisplayName,
                value: project.cfId,
                disabled: false,
              });
            }
          });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('PRS60');
      });
  }

  isStartedProject(project) {
    const today = new Date(dateTimeHelper.toYYYYsMMsDD(new Date()));
    const endDate = new Date(
      dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(new Date(project.cfEndDate), 30))
    );
    return new Date(project.cfStartDate) < today && today < endDate;
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
